import StepCustomization from "@dashboard/modules/shared/components/onboarding-shared/pages/step-customization/step-customization";
import { FC } from "react";

const OnboardingCustomization: FC = () => {
  return <StepCustomization planPath="/onboarding/premium" />;
};

export default OnboardingCustomization;